import { ArrowRight, Image, MessageCircle, Users } from 'lucide-react'

const items = [
  {
    icon: MessageCircle,
    title: 'Ask and answer',
    body: 'Get help with IMAP, SMTP, security, signatures, or a provider that is acting strangely.',
    href: '/forum',
    label: 'Open the forum',
  },
  {
    icon: Image,
    title: 'Show your setup',
    body: 'Share screenshots, signature designs, and the little workflow details that make a desk feel yours.',
    href: '/forum/gallery',
    label: 'Browse the gallery',
  },
  {
    icon: Users,
    title: 'Shape the roadmap',
    body: 'Report bugs, request features, and help test the next release with other NewEmail users.',
    href: '/support',
    label: 'Get involved',
  },
]

export function CommunityCallout() {
  return (
    <section className="py-16 md:py-24">
      <div className="mx-auto max-w-7xl px-4">
        <div className="overflow-hidden rounded-3xl bg-sidebar px-6 py-10 text-sidebar-foreground shadow-2xl shadow-[#3e251d]/20 md:px-10 md:py-12">
          <div className="grid gap-8 lg:grid-cols-[0.7fr_1.3fr] lg:items-end">
            <div>
              <span className="font-mono text-sm font-semibold text-[#ff9b65]">
                // better together
              </span>
              <h2 className="mt-3 text-balance text-3xl font-extrabold tracking-tight text-white sm:text-4xl">
                A place to compare notes.
              </h2>
              <p className="mt-4 max-w-md text-sm leading-relaxed text-white/65">
                The NewEmail community is for practical help, thoughtful requests, and the joy of a
                tool that works the way you expect.
              </p>
            </div>
            <div className="grid gap-3 md:grid-cols-3">
              {items.map(({ icon: Icon, title, body, href, label }) => (
                <a
                  key={title}
                  href={href}
                  className="group rounded-2xl border border-white/10 bg-white/5 p-5 transition-colors hover:bg-white/10"
                >
                  <Icon className="h-5 w-5 text-[#ff9b65]" />
                  <h3 className="mt-4 font-bold text-white">{title}</h3>
                  <p className="mt-2 text-xs leading-relaxed text-white/60">{body}</p>
                  <span className="mt-5 flex items-center gap-1.5 text-xs font-semibold text-[#ffb28a]">
                    {label}
                    <ArrowRight className="h-3.5 w-3.5 transition-transform group-hover:translate-x-1" />
                  </span>
                </a>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}
